export const INDENTS = { beetween: 8 };
export const SLIDE_WIDTH = 110;
